import type { ReactNode } from 'react'
import { Card, CardContent } from '@insightai/ui'
import { Link } from 'react-router-dom'

/**
 * Shared frame for the auth screens.
 *
 * §6.2 calls these "modal-first, deep-linkable". They are implemented as real
 * pages: a prerendered page works with JS disabled, is shareable, survives a
 * refresh, and renders identically when reached from a link or from the nav.
 * A modal that also has to work as a standalone route is two code paths for one
 * screen — and the standalone one is invariably the untested one.
 */
export function AuthLayout({
  title,
  subtitle,
  children,
  footer,
}: {
  title: string
  subtitle?: string
  children: ReactNode
  footer?: ReactNode
}) {
  return (
    <div className="mx-auto flex w-full max-w-md flex-col gap-6 px-4 py-16 sm:px-0">
      <div className="flex flex-col gap-2 text-center">
        <Link to="/" className="mx-auto flex w-fit items-center gap-2 text-body font-semibold">
          <span
            aria-hidden
            className="flex size-7 items-center justify-center rounded-md bg-brand-solid text-caption font-bold text-text-on-brand"
          >
            iA
          </span>
          InsightAI
        </Link>
        <h1 className="text-h1">{title}</h1>
        {subtitle && <p className="text-body-sm text-text-secondary">{subtitle}</p>}
      </div>

      <Card>
        <CardContent className="pt-6">{children}</CardContent>
      </Card>

      {footer && <div className="text-center text-body-sm text-text-secondary">{footer}</div>}
    </div>
  )
}
